import {
	TUploadExcelApplicantItem,
	TUploadExcelAssignmentItem,
	TUploadExcelFranchiseItem,
	TUploadExcelLodgingItem,
	TUploadExcelPublicAssignmentItem,
	TUploadExcelRecommenderItem,
} from '@/services';

// change this value if template has changed
export const ROW_HEADER_APPLICANT = [7];
export const ROW_HEADER_FRANCHISE = [7];
export const ROW_HEADER_ASSIGNMENT = [7, 8];
export const ROW_HEADER_RECOMMENDER = [7, 8];
export const ROW_HEADER_LODGING = [7, 8];
export const ROW_HEADER_PUBLIC_ASSIGNMENT = [5, 6];
export const COLUMN_START = 2;
export const COLUMN_START_CUSTOM_FIELD_APPLICANT = 'AK';
export const COLUMN_START_CUSTOM_FIELD_FRANCHISE = 'AF';
export const CELL_PROGRAM_NAME_ASSIGNMENT_HEADER = 'B4';
export const CELL_PROGRAM_NAME_ASSIGNMENT_HEADER_DATA = 'E4';
export const CELL_PROGRAM_NAME_ASSIGNMENT_REASON_FAIL = 'I4';
export const NUMBER_OF_CUSTOM_FIELD_APPLICANT = 5;
export const NUMBER_OF_CUSTOM_FIELD_FRANCHISE = 5;
export const NUMBER_OF_TEMPLATE_APPLICANT = 35;
export const NUMBER_OF_TEMPLATE_FRANCHISE = 30;

export const OPTIONAL_HEADERS_APPLICANT = ['실패 이유'];
export const OPTIONAL_HEADERS_FRANCHISE = ['실패 이유'];
export const OPTIONAL_HEADERS_ASSIGNMENT = ['실패 이유'];
export const OPTIONAL_HEADERS_RECOMMENDER = ['실패 이유'];
export const OPTIONAL_HEADERS_LODGING = ['실패 이유'];
export const OPTIONAL_HEADERS_PUBLIC_ASSIGNMENT = ['실패 이유'];

export const MAX_ROW_EXCEL = 1000;

export const FILE_TYPE_EXPORT_EXCEL =
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export enum TypeTemplateExcelEnum {
	TEMPLATE = 'template',
	CURRENT_DATA = 'currentData',
	FAILED_DATA = 'failedData',
}

export const TEMPLATE_APPLICANT_FIELDS: Array<{
	label: string;
	value: keyof TUploadExcelApplicantItem;
}> = [
	{ label: '읍/면', value: 'district' },
	{ label: '성', value: 'firstName' },
	{ label: '이름', value: 'lastName' },
	{ label: '생년월일', value: 'birthDate' },
	{ label: '아이디', value: 'email' },
	{ label: '성별', value: 'gender' },
	{ label: '키', value: 'height' },
	{ label: '몸무게', value: 'weight' },
	{ label: '전화번호', value: 'phone' },
	{ label: '본국 주소', value: 'hometownAddr' },
	{ label: '본국 전화번호', value: 'hometownPhone' },
	{ label: '국적', value: 'nationalCode' },
	{ label: '여권번호', value: 'passportNo' },
	{ label: '여권 발급일자', value: 'passportIssueDate' },
	{ label: '여권 만료일자', value: 'passportExpireDate' },
	{ label: '지원형태', value: 'applicationType' },
	{ label: '재입국', value: 'isReEntry' },
	{ label: '재입국 횟 수', value: 'reEntryCount' },
	{ label: '공공형', value: 'isPublic' },
	{ label: '공공형 사업자', value: 'publicFranchiseName' },
	{ label: '등급', value: 'grade' },
	{ label: '상태', value: 'status' },
	{ label: '사증발급인정번호', value: 'visaIssuanceConfirmNo' },
	{ label: '사증인증번호', value: 'visaNo' },
	{ label: '외국인등록번호', value: 'foreignerNo' },
	{ label: '입국일자', value: 'entryDate' },
	{ label: '체류자격', value: 'visaCode' },
	{ label: '체류기간', value: 'visaTime' },
	{ label: '체류연장 기간', value: 'extensionPeriod' },
	{ label: '근무처변경 일자', value: 'changeWorkDate' },
	{ label: '무단이탈 일자', value: 'unauthorizedDepartureDate' },
	{ label: '출국 예정 D-DAY', value: 'departureDateDDay' },
	{ label: '출국 일자', value: 'departureDate' },
	{ label: '특이사항', value: 'memo' },
	{ label: '중도 출국', value: 'midTermDeparture' },
];

export const TEMPLATE_LODGING_FIELDS: Array<{
	label: string;
	value: keyof TUploadExcelLodgingItem;
}> = [
	{ label: '숙소_ID', value: 'id' },
	{ label: '숙소_읍/면', value: 'district' },
	{ label: '숙소_숙소 주소', value: 'address' },
	{ label: '숙소_소유형태', value: 'ownershipType' },
	{ label: '숙소_시설종류', value: 'facilityType' },
	{ label: '숙소_숙소 제공일', value: 'providedDate' },
	{ label: '숙소_숙소 점검일', value: 'inspectionDate' },
	{ label: '제공자_구분', value: 'providerType' },
	{ label: '제공자_이름', value: 'providerName' },
	{ label: '제공자_국적', value: 'providerNationalCode' },
	{ label: '제공자_전화번호', value: 'providerPhone' },
	{ label: '제공자_주소', value: 'providerAddress' },
	{ label: '특이사항', value: 'memo' },
	{ label: '숙박비', value: 'lodgingCost' },
	{ label: '식비', value: 'mealCost' },
];

export const TEMPLATE_RECOMMENDER_FIELDS: Array<{
	label: string;
	value: keyof TUploadExcelRecommenderItem;
}> = [
	{ label: 'ID', value: 'id' },
	{ label: '구분', value: 'type' },
	{ label: '추천자_추천자', value: 'name' },
	{ label: '결혼이민자 추천자_생년월일', value: 'birthDateStr' },
	{ label: '결혼이민자 추천자_전화번호', value: 'phone' },
	{ label: '결혼이민자 추천자_주소', value: 'address' },
	{ label: '결혼이민자 추천자_이메일', value: 'email' },
	{ label: '결혼이민자 추천자_영문이름', value: 'engName' },
	{ label: '결혼이민자 추천자_이전 국적', value: 'providerNational' },
	{ label: '결혼이민자 추천자_체류자격', value: 'visaCode' },
	{ label: '배우자_구분', value: 'subType' },
	{ label: '배우자', value: 'spouseName' },
	{ label: '배우자_전화번호', value: 'spousePhone' },
	{ label: '추천 인원', value: 'recommendedNumberPeople' },
	{ label: '특이사항', value: 'memo' },
];

export const TEMPLATE_ASSIGNMENT_FIELDS: Array<{
	label: string;
	value: keyof TUploadExcelAssignmentItem;
}> = [
	{ label: '프로그램명', value: 'programName' },
	{ label: '근로자_성', value: 'applicantFirstName' },
	{ label: '근로자_이름', value: 'applicantLastName' },
	{ label: '근로자_생년월일', value: 'applicantBirthDate' },
	{ label: '근로자_이메일', value: 'applicantEmail' },
	{ label: '근로자_비고', value: 'applicantMemo' },
	{ label: '사업장_고용주', value: 'franchiseName' },
	{ label: '사업장_이메일', value: 'franchiseEmail' },
	{ label: '배정_배정 시작일', value: 'startDate' },
	{ label: '배정_배정 종료일', value: 'endDate' },
	{ label: '배정_요청인원', value: 'requestApplicant' },
	{ label: '특이사항', value: 'memo' },
];

export const TEMPLATE_PUBLIC_ASSIGNMENT_FIELDS: Array<{
	label: string;
	value: keyof TUploadExcelPublicAssignmentItem;
}> = [
	// { label: '프로그램명', value: 'programName' },
	{ label: '사업장_고용주', value: 'employerName' },
	{ label: '사업장_고용주 생년월일', value: 'employerBirthDate' },
	{ label: '배정_배정 일자', value: 'workingDate' },
	{ label: '배정_근무 시작 시간', value: 'startTime' },
	{ label: '배정_근무 종료 시간', value: 'endTime' },
	{ label: '배정_휴게시간', value: 'relaxTime' },
	{ label: '배정_총 인원', value: 'requestApplicant' },
	{ label: '자동 배정_자동 여부', value: 'autoAssignment' },
	{ label: '자동 배정_남자 수', value: 'numberOfMale' },
	{ label: '자동 배정_남자 연령대', value: 'ageOfMale' },
	{ label: '자동 배정_여자 수', value: 'numberOfFemale' },
	{ label: '자동 배정_여자 연령대', value: 'ageOfFemale' },
	{ label: '수동 배정 근로자_성', value: 'applicantFirstName' },
	{ label: '수동 배정 근로자_이름', value: 'applicantLastName' },
	{ label: '수동 배정 근로자_생년월일', value: 'applicantBirthDate' },
	{ label: '특이사항', value: 'memo' },
];

export const TEMPLATE_FRANCHISE_FIELDS: Array<{
	label: string;
	value: keyof TUploadExcelFranchiseItem;
}> = [
	{ label: '구분', value: 'type' },
	{ label: '사업장 구분 상세', value: 'typeDetail' },
	{ label: '읍/면', value: 'district' },
	{ label: '고용주', value: 'employerName' },
	{ label: '고용주 아이디', value: 'email' },
	{ label: '사업장 주소', value: 'address' },
	{ label: '고용주 생년월일', value: 'employerBirthDate' },
	{ label: '고용주 전화번호', value: 'employerPhone' },
	{ label: '사업장', value: 'name' },
	{ label: '사업장 전화번호', value: 'phone' },
	{ label: '작물/수산물 종류', value: 'productionType' },
	{ label: '작물/수산물 상세', value: 'productionTypeDetail' },
	{ label: '재배면적 /생산단위', value: 'productionScale' },
	{ label: '최대 허용 인원', value: 'maxManpowerAllowed' },
	{ label: '공공형', value: 'isPublic' },
	{ label: '공공형 사업자', value: 'publicFranchiseName' },
	{ label: '농어업경영체 등록번호', value: 'businessRegistNo' },
	{ label: '법인·조합 등록번호', value: 'corporateRegistNo' },
	{ label: '누적 벌점', value: 'penaltyPointsAccumulated' },
	{ label: '배정 제한 대상 여부', value: 'isAllocationRestricted' },
	{ label: '일 근무 시간', value: 'workingTime' },
	{ label: '월 근무 시간', value: 'monthlyWorkingHours' },
	{ label: '일 휴게 횟 수', value: 'dailyBreaksNumber' },
	{ label: '일 휴게 시간', value: 'dailyBreaksHour' },
	{ label: '일 휴게 분', value: 'dailyBreaksMin' },
	{ label: 'A등급 일급', value: 'gradeADailyWage' },
	{ label: 'B등급 일급', value: 'gradeBDailyWage' },
	{ label: 'C등급 일급', value: 'gradeCDailyWage' },
	{ label: '기본등급', value: 'defaultGrade' },
	{ label: '특이사항', value: 'memo' },
];

export const EXCEL_RESULT_MESSAGES = {
	EXCEL_RESULT_ALL_1: (field: string) =>
		`${field}의 입력 양식에 맞지 않습니다.`,
	EXCEL_RESULT_ALL_2: (field: string) =>
		`${field}의 입력 양식에 맞지 않습니다.`,
	EXCEL_RESULT_ALL_3: '사용할 수 없는 이메일입니다.',
	EXCEL_RESULT_ALL_4: '사용자 옵션 명이 일치하지 않습니다.',
	EXCEL_RESULT_ALL_5_AR: (townOrVillage: string) =>
		`${townOrVillage} 근로자만 등록할 수 있습니다.`,
	EXCEL_RESULT_ALL_5_FR: (townOrVillage: string) =>
		`${townOrVillage} 사업장만 등록할 수 있습니다.`,
	EXCEL_RESULT_ALL_6_AR:
		'공공형 근로자는 공공형 사업자(농협)의 읍/면정보와 동일한 읍/면 정보여야합니다.',
	EXCEL_RESULT_ALL_6_FR:
		'공공형 사업장는 공공형 사업자(농협)의 읍/면정보와 동일한 읍/면 정보여야합니다.',
	EXCEL_RESULT_ALL_7:
		'이미 배정된 정보가 존재하여 읍/면 정보를 변경할 수 없습니다.',
	EXCEL_RESULT_ALL_8: '읍/면 값을 입력해주세요.',

	EXCEL_RESULT_AR_1:
		'공공형 사업자(농협)은 공공형 값이 ‘O’, ‘예’일 경우, 입력할 수 있습니다.',
	EXCEL_RESULT_AR_2:
		'입력한 공공형 사업자(농협)는 사업장 관리 메뉴에 등록되지 않거나 잘못 입력된 공공형 사업자입니다.',
	EXCEL_RESULT_AR_3:
		'이미 등록된 성, 이름, 생년월일입니다. 업데이트 하려면 이메일을 입력해주세요.',
	EXCEL_RESULT_AR_4:
		'재입국 횟 수는 재입국 값이 ‘O’, ‘예’일 경우, 입력할 수 있습니다.',
	EXCEL_RESULT_AR_5: (field: string) =>
		`'공공형'으로 배정된 내역이 있으면, ${field} 값을 변경할 수 없습니다.`,
	EXCEL_RESULT_AR_6: '체류 연장은 최대 8개월까지 가능합니다.',
	EXCEL_RESULT_AR_7:
		'체류 자격을 입력한 후에 체류 기간과 체류 연장 기간을 입력할 수 있습니다.',
	EXCEL_RESULT_AR_8: '체류 자격 E-8은 체류기간 ‘90일’을 입력할 수 없습니다.',
	EXCEL_RESULT_AR_9:
		'체류 자격 C-4은 체류기간 ‘90일’만 입력할 수 있고 체류 연장을 할 수 없습니다.',
	EXCEL_RESULT_AR_11:
		'중도 출국 값을 입력한 근로자에게 출국 일자 이 후에 남아 있는 공공형 배정 정보가 있습니다. 남아 있는 배정 정보를 삭제해주세요.',
	EXCEL_RESULT_AR_12:
		'입국 일자과 체류 기간을 입력한 후에  체류 연장 기간을 입력할 수 있습니다.',

	AR1_MID_TERM_DEPARTURE_DATE_IS_NULL: '출국일자를 먼저 입력해주세요.',
	AR1_MID_TERM_DEPARTURE_DATE_IS_PAST:
		'중도 출국은 출국일자가 미래일 때 입력할 수 있습니다.',

	EXCEL_RESULT_FR_1:
		'공공형 사업자(농협)은 공공형 값이 ‘O’, ‘예’일 경우, 입력할 수 있습니다.',
	EXCEL_RESULT_FR_2:
		'입력한 공공형 사업자(농협)는 사업장 관리 메뉴에 등록되지 않거나 잘못 입력된 공공형 사업자입니다.',
	EXCEL_RESULT_FR_3:
		'A등급, B등급, C등급, 기본 등급 값은 구분 상세 값이 ‘공공형 사업자’이거나, ‘공공형 사업자’ 값을 입력한 경우, 입력할 수 있습니다.',
	EXCEL_RESULT_FR_4:
		'이미 등록된 사업장, 농업/어업 등록번호 또는 법인/조합 등록번호입니다. 업데이트 하려면 이메일을 입력해주세요.',
	EXCEL_RESULT_FR_5:
		'공공형 사업장일 경우, 공공형 사업장(농협) 값을 입력해주세요.',
	EXCEL_RESULT_FR_6:
		'이미 사용중인 공공형 사업장는 구분 상세 값을 변경할 수 없습니다.',
	EXCEL_RESULT_FR_7: (field: string) =>
		`이미 사용중인 공공형 사업장는 ${field} 값을 변경할 수 없습니다.`,
	EXCEL_RESULT_FR_8:
		'사업장 구분 상세가 공공형 사업자이 경우, 작물/수산물 종류, 작물/수산물 상세를 입력할 수 없습니다.',

	EXCEL_RESULT_RM_1:
		'구분이 MOU일 경우, 추천자(추천자)와 특이사항 이 외에 정보를 입력할 수 없습니다.',
	EXCEL_RESULT_RM_2:
		'입력한 배우자(배우자)는 사업장 관리 메뉴에 등록되지 않은 고용주입니다.',

	EXCEL_RESULT_LM_1:
		'이미 등록된 숙소주소입니다. 업데이트 하려면 ID를 입력해주세요.',
	EXCEL_RESULT_LM_2:
		'입력한 제공자(제공자)는 사업장 관리 메뉴에 등록되지 않은 고용주입니다',
	EXCEL_RESULT_LM_3:
		'입력한 제공자(제공자)는 추천자 관리 메뉴에 등록되지 않은 추천자입니다.',
	EXCEL_RESULT_LM_4: (townOrVillage: string) =>
		`${townOrVillage}의 숙소와 사업장만 등록할 수 있습니다.`,
	EXCEL_RESULT_LM_5:
		'숙소 읍/면 정보와 사업장 또는 추천자 읍/면 정보가 동일한 정보만 등록할 수 있습니다.',
	EXCEL_RESULT_LM_6_FRANCHISE: `동일한 고용주 정보가 있어 등록할 수 없습니다.`,
	EXCEL_RESULT_LM_6_RECOMMENDER: `동일한 추천자 정보가 있어 등록할 수 없습니다.`,

	EXCEL_RESULT_AM_1: '요청인원은 같은 배정에 1개의 셀에만 입력할 수 있습니다.',
	EXCEL_RESULT_AM_2:
		'입력한 근로자는 근로자 관리 메뉴에 등록되지 않거나 잘못 입력된 근로자입니다.',
	EXCEL_RESULT_AM_3:
		'입력한 사업장은 사업장 관리 메뉴에 등록되지 않거나 잘못 입력된 사업장입니다.',
	EXCEL_RESULT_AM_4:
		'근로자 입력 시, 이름, 생년월일, 이메일 항목을 모두 입력해야합니다.',
	EXCEL_RESULT_AM_5: '유효하지 않은 배정정보 입니다.',
	EXCEL_RESULT_AM_6:
		'공공형 근로자는 공공형 사업자(농협)의 읍/면정보와 동일한 읍/면 정보여야합니다.',

	EXCEL_RESULT_PAM_1: '총 인원은 남자 수, 여자 수를 합한 값이여야 합니다.',
	EXCEL_RESULT_PAM_2_MALE: (numberOfMale: number) =>
		`설정한 남자 ${numberOfMale}명 보다 근무 가능한 남자 근로자가 적습니다.`,
	EXCEL_RESULT_PAM_2_FEMALE: (numberOfFemale: number) =>
		`설정한 여자 ${numberOfFemale}명 보다 근무 가능한 여자 근로자가 적습니다.`,
	EXCEL_RESULT_PAM_2_FEMALE_AND_MALE: (numberOfMaleAndFemale: number) =>
		`설정한 남자와 여자 ${numberOfMaleAndFemale}명 보다 근무 가능한 남자와 여자 근로자가 적습니다.`,
	EXCEL_RESULT_PAM_3: '입력한 조건에 맞춰 배정할 수 있는 근로자가 없습니다.',
	EXCEL_RESULT_PAM_4: (field: string) =>
		`동일한 이름의 ${field}가 있습니다. ${field}를 구분할 수 있도록 생년월일을 입력해주세요.`,
	EXCEL_RESULT_PAM_5: (field: string) =>
		`동일한 이름과 생년월일의 ${field}가 있어 엑셀로 등록할 수 없습니다. 서비스에서 직접 등록해주세요.`,
	EXCEL_RESULT_PAM_6: (minimumRelaxTime: number) =>
		`휴게시간이 근무 시간의 최소 휴게 시간보다 적습니다. 휴게 시간을 최소 ${minimumRelaxTime}이상 시간으로 변경해주세요.`,
	EXCEL_RESULT_PAM_7: '해당 날짜에 이미 배정된 근로자는 배정할 수 없습니다.',
	EXCEL_RESULT_PAM_8: '동일한 소속의 농협 근로자, 사업장이 아닙니다.',

	EXCEL_RESULT_AM_AM1_INVALID_DISTRICT_ALERT_63:
		'이미 배정된 정보가 존재하여 읍/면 정보를 변경할 수 없습니다.',
};

export const CUSTOM_FIELD_KEYS = {
	applicant: Array.from(
		{ length: 5 },
		(_, i) => `applicantCustomField${i + 1}`
	),
	franchise: Array.from(
		{ length: 5 },
		(_, i) => `franchiseCustomField${i + 1}`
	),
} as const;
